import React from "react";
import {
  Box,
  createStyles,
  TableBody,
  TableCell,
  TableRow,
  withStyles,
} from "@material-ui/core";
import { Row } from "../../../modules/list-pc/types";
import classes from "./index.module.scss";
import { Utils } from "modules/utils";
import { XUANAPI } from "modules/uri";
import { useHistory } from "react-router-dom";

const StyledTableRow = withStyles(() =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: `#EEEEEE`,
      },
    },
  })
)(TableRow);

const getToken = () => {
  return localStorage.getItem("token");
};

const getInvoice = async (
  policynUM: string,
  id: string,
  token: string,
  download: boolean
) => {
  try {
    const data = { id: id, policyNumber: policynUM };
    const resp = await fetch(
      download ? `${XUANAPI}/download` : `${XUANAPI}/view`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      }
    );

    const respData = await resp.json();
    return respData;
  } catch (err) {
    return null;
  }
};

const showPdf = async (
  id: string,
  policynum: string,
  token: string,
  history: any
) => {
  const resp = await getInvoice(policynum, id, token, false);

  if (resp && resp.status === "SUCCESS") {
    const blob = Utils.b64toBlob(resp.bytes64bytes, resp.mimeType);

    const a = document.createElement("a");
    document.body.appendChild(a);

    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.target = "_blank";
    a.click();

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);

    return;
  }

  history.goBack();
};

const downloadZipFile = async (
  id: string,
  policynum: string,
  token: string,
  history: any
) => {
  const resp = await getInvoice(policynum, id, token, true);

  if (resp && resp.status === "SUCCESS") {
    const mimeType = "application/zip";
    const blob = Utils.b64toBlob(resp.database64, mimeType);

    const a = document.createElement("a");
    document.body.appendChild(a);

    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = resp.fileName + ".zip";
    a.click();

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);

    return;
  }

  history.goBack();
};

export const TableDataColumns = (row: Row, key: number): JSX.Element => {
  const token = getToken();
  const history = useHistory();

  return (
    <StyledTableRow hover key={`` + key}>
      <TableCell align="center">{row.receiptDate || ""}</TableCell>
      <TableCell align="center">{row.taxNum || ``}</TableCell>
      <TableCell align="center">
        {row.receiptAmount ? Utils.numberWithCommas(row.receiptAmount) : ""}
      </TableCell>
      <TableCell align="center">
        {row.polNum && row.id ? (
          <Box display="flex" alignItems="center" justifyContent="center">
            <a
              href="/#"
              className={classes.downloadLink}
              onClick={(e) => {
                e.preventDefault();
                token && showPdf(row.id, row.polNum, token, history);
              }}
            >
              <Box display="flex" alignItems="center" justifyContent="center">
                <span>Xem</span>
              </Box>
            </a>
            <a
              href="/#"
              className={classes.downloadLink}
              onClick={(e) => {
                e.preventDefault();
                token && downloadZipFile(row.id, row.polNum, token, history);
              }}
            >
              <Box display="flex" alignItems="center" justifyContent="center">
                <span>Tải hợp lệ</span>
              </Box>
            </a>
          </Box>
        ) : (
          ``
        )}
      </TableCell>
    </StyledTableRow>
  );
};

export const TableDataMobile = (row: Row): JSX.Element => {
  const token = getToken();
  const history = useHistory();

  return (
    <TableBody>
      <TableRow>
        <TableCell style={{ fontWeight: `bold` }}>Ngày</TableCell>
        <TableCell>{row.receiptDate || ""}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ fontWeight: `bold` }}>Số tax</TableCell>
        <TableCell>{row.taxNum || ``}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ fontWeight: `bold` }}>Số tiền phí (đồng)</TableCell>
        <TableCell>
          {row.receiptAmount ? Utils.numberWithCommas(row.receiptAmount) : ""}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ fontWeight: `bold` }}>Link E-invoice</TableCell>
        <TableCell>
          {row.polNum && row.id ? (
            <Box display="flex" alignItems="center">
              <a
                href="/#"
                className={classes.downloadLink}
                onClick={(e) => {
                  e.preventDefault();
                  token && showPdf(row.id, row.polNum, token, history);
                }}
              >
                <Box display="flex" alignItems="center" justifyContent="center">
                  <span>Xem</span>
                </Box>
              </a>
              <a
                href="/#"
                className={classes.downloadLink}
                onClick={(e) => {
                  e.preventDefault();
                  token && downloadZipFile(row.id, row.polNum, token, history);
                }}
              >
                <Box display="flex" alignItems="center" justifyContent="center">
                  <span>Tải hợp lệ</span>
                </Box>
              </a>
            </Box>
          ) : (
            ``
          )}
        </TableCell>
      </TableRow>
    </TableBody>
  );
};
